import { faComments } from '@fortawesome/free-regular-svg-icons';
import { faLock, faReply, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChevronDownLegacy, ChevronUp } from '@wfp/icons-react';
import { Text } from '@wfp/react';
import { formatDistanceToNow } from 'date-fns';
import React, { FC, useState } from 'react';

import { IIssue } from 'src/types';
import { getDateWithTimezone, getUserInfo } from 'src/utils';

interface Props {
  issue: IIssue;
}

const iconStyles = {
  width: '30px',
  height: '30px',
  color: 'grey',
};

const IssueItem: FC<Props> = ({ issue }) => {
  const [isOpen, setIsOpen] = useState(!issue.closed);

  return (
    <div className="io-issue-item" key={issue.pk}>
      <div className="io-issue-item-header">
        <div className="io-issue-item-left-col">
          <div className="io-issue-item-tags">
            {issue.restored && (
              <span className="thread-restored-label">
                <span>Restored</span>
              </span>
            )}
            {issue.closed && (
              <span className="closed-comment-badge">
                <FontAwesomeIcon icon={faLock} />
                <span>Closed</span>
              </span>
            )}
            {issue.important && !issue.closed && (
              <span className="high-importance-badge">
                <FontAwesomeIcon icon={faStar} />
                <span>High Importance</span>
              </span>
            )}
          </div>
          <div className="io-issue-item-left-col-wrapper-content">
            <FontAwesomeIcon
              icon={faComments}
              className="acr-comment-title-icon"
              {...iconStyles}
            />
            <div className="io-issue-item-left-col-content">
              <div className="io-issue-item-title">
                <Text>{issue.title}</Text>
              </div>
              <div className="io-issue-item-info">
                <div className="io-issue-item-author">
                  <Text>{getUserInfo(issue?.user)}</Text>
                </div>
                <div className="io-issue-item-id">
                  <Text>ID: {issue.pk}</Text>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="io-issue-item-right-col">
          <div className="io-iirc-date">
            <Text>{getDateWithTimezone(issue?.date)}</Text>
            <Text>{`${formatDistanceToNow(issue?.date?.date)} ago`}</Text>
          </div>
          {isOpen ? (
            <ChevronUp
              className="acr-comment-title-icon acr-comment-accordion-icon"
              onClick={() => setIsOpen(!isOpen)}
              {...iconStyles}
            />
          ) : (
            <ChevronDownLegacy
              className="acr-comment-title-icon acr-comment-accordion-icon"
              onClick={() => setIsOpen(!isOpen)}
              {...iconStyles}
            />
          )}
        </div>
      </div>
      {isOpen && (
        <>
          <div className="io-item-separator"></div>
          <div className="io-issue-item-content">
            <Text>{issue.content}</Text>
          </div>
          {issue.comments?.map(comment => {
            return (
              <div className="io-item-comment" key={comment.pk}>
                <div className="io-item-comment-header">
                  <div className="io-item-comment-left-col">
                    <div>
                      <FontAwesomeIcon
                        icon={faReply}
                        className="acr-comment-title-icon"
                        {...iconStyles}
                        style={{ transform: 'scaleX(-1)' }}
                      />
                    </div>
                    <div>
                      <div className="io-item-comment-title">
                        <Text>{getUserInfo(comment?.user)}</Text>
                      </div>
                      <Text className="reply-id">ID: {comment.pk}</Text>
                    </div>
                  </div>
                  <div className="io-item-comment-right-col">
                    <Text>{getDateWithTimezone(comment?.date)}</Text>
                    <Text>{`${formatDistanceToNow(
                      issue?.date?.date,
                    )} ago`}</Text>
                  </div>
                </div>
                <Text>{comment.content}</Text>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default IssueItem;
